import { render } from "./TopPerformers.vue?vue&type=template&id=231b2c03"
import script from "./TopPerformers.vue?vue&type=script&lang=js"
export * from "./TopPerformers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__